import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import httpclient from './plugins/httpclient';
import store from './plugins/store.js';

Vue.config.productionTip = false
Vue.prototype.$http = httpclient;


new Vue({
  vuetify,
  router,
  store,
  httpclient,
  render: h => h(App)
}).$mount('#app')
